import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services">
      {/* Hero Section */}
      <section className="services-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Our Services</h1>
            <p className="hero-subtitle">
              We help you define, plan for, and achieve your most important financial goals with objective advice and personalized guidance.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="section services-grid">
        <div className="container">
          <div className="grid grid-cols-2">
            {/* Investments */}
            <div className="service-detail-card">
              <div className="service-detail-icon">📈</div>
              <h3>Investments</h3>
              <p>
                Professional investment management with access to institutional-quality money managers. 
                We create customized investment strategies designed to grow your wealth while managing risk appropriately.
              </p>
              <ul className="service-features">
                <li>Access to top institutional money managers</li>
                <li>Customized investment strategies</li>
                <li>Professional portfolio monitoring</li>
                <li>Risk management and diversification</li>
              </ul>
            </div>

            {/* Portfolio Design */}
            <div className="service-detail-card">
              <div className="service-detail-icon">🎯</div>
              <h3>Portfolio Design</h3>
              <p>
                Strategic portfolio construction tailored to your specific financial goals, risk tolerance, 
                and time horizon. We build portfolios designed to optimize returns while managing downside risk.
              </p>
              <ul className="service-features">
                <li>Customized asset allocation strategies</li>
                <li>Goal-based portfolio construction</li>
                <li>Risk tolerance assessment</li>
                <li>Regular portfolio rebalancing</li>
              </ul>
            </div>

            {/* Portfolio Tax-Efficiency */}
            <div className="service-detail-card">
              <div className="service-detail-icon">💼</div>
              <h3>Portfolio Tax-Efficiency</h3>
              <p>
                Tax-smart investment strategies designed to minimize the impact of taxes on your investment returns. 
                We implement strategies to help you keep more of what you earn.
              </p>
              <ul className="service-features">
                <li>Tax-loss harvesting strategies</li>
                <li>Asset location optimization</li>
                <li>Tax-efficient fund selection</li>
                <li>Municipal bond strategies when appropriate</li>
              </ul>
            </div>

            {/* Retirement Income Planning */}
            <div className="service-detail-card">
              <div className="service-detail-icon">🏦</div>
              <h3>Retirement Income Planning</h3>
              <p>
                Comprehensive retirement planning to ensure you have the income you need throughout your retirement years. 
                We help you create a sustainable retirement income strategy.
              </p>
              <ul className="service-features">
                <li>Retirement income projections</li>
                <li>Social Security optimization</li>
                <li>401(k) and IRA planning</li>
                <li>Healthcare cost planning</li>
              </ul>
            </div>

            {/* Tax Reduction Strategies */}
            <div className="service-detail-card">
              <div className="service-detail-icon">📊</div>
              <h3>Tax Reduction Strategies</h3>
              <p>
                Proactive tax planning strategies designed to minimize your tax burden and maximize your after-tax wealth. 
                We work with your tax professional to implement effective strategies.
              </p>
              <ul className="service-features">
                <li>Year-round tax planning</li>
                <li>Roth IRA conversion strategies</li>
                <li>Charitable giving strategies</li>
                <li>Estate tax planning</li>
              </ul>
            </div>

            {/* Insurance & Benefits Planning */}
            <div className="service-detail-card">
              <div className="service-detail-icon">🛡️</div>
              <h3>Insurance & Benefits Planning</h3>
              <p>
                Comprehensive insurance and benefits analysis to protect your wealth and ensure your family's financial security. 
                We help you optimize your protection strategies.
              </p>
              <ul className="service-features">
                <li>Life insurance needs analysis</li>
                <li>Disability insurance planning</li>
                <li>Long-term care planning</li>
                <li>Employee benefits optimization</li>
              </ul>
            </div>

            {/* College Savings Strategies */}
            <div className="service-detail-card">
              <div className="service-detail-icon">🎓</div>
              <h3>College Savings Strategies</h3>
              <p>
                Strategic planning for education expenses to help ensure your children's educational goals are met 
                without compromising your retirement security.
              </p>
              <ul className="service-features">
                <li>529 plan optimization</li>
                <li>Educational funding strategies</li>
                <li>Financial aid planning</li>
                <li>Tax-efficient education savings</li>
              </ul>
            </div>

            {/* Wedding Funds */}
            <div className="service-detail-card">
              <div className="service-detail-icon">💒</div>
              <h3>Wedding Funds</h3>
              <p>
                Specialized savings and investment strategies to help you fund wedding expenses while maintaining 
                your long-term financial goals.
              </p>
              <ul className="service-features">
                <li>Goal-based savings strategies</li>
                <li>Timeline-appropriate investments</li>
                <li>Budget planning assistance</li>
                <li>Liquidity management</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section services-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Get Started?</h2>
            <p>
              Let us help you create a comprehensive financial plan tailored to your unique goals and circumstances. 
              Contact us today to schedule a consultation.
            </p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Schedule a Consultation
              </Link>
              <Link to="/about" className="btn btn-secondary">
                Learn More About Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services; 